import { createIcon } from './icon-utils';

export const DownArrowIconSize12 = createIcon({
  path: 'M9.32857 4.63727C9.62814 4.35121 10.1029 4.36216 10.389 4.66173C10.675 4.9613 10.6641 5.43605 10.3645 5.72211L6.84654 9.08141C6.65997 9.25983 6.4114 9.35826 6.15422 9.35826C5.89704 9.35826 5.64847 9.25983 5.46232 9.0818L1.94396 5.72211C1.64439 5.43605 1.63344 4.9613 1.9195 4.66173C2.20556 4.36216 2.6803 4.35121 2.97987 4.63727L6.15422 7.66847L9.32857 4.63727Z',
  style: { height: 12, width: 12 },
  viewBox: '0 0 12 12',
});
